module.exports = __webpack_public_path__ + "static/media/HeaderBottom_Desktop.c9829d95.png";